import React from 'react'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { Link } from 'react-router-dom'
import utils from '../../Utils'

const clickCategoryItem = (categoryName) => {
  console.log('tag manager', 'click on category item')
  utils.sendGtmEvent('Engage', `Click / ${categoryName}`)
}

const ConsultCategoryItem = ({ category }) =>
  <Link to={`/categories/${category.id}/doctors`} className='cols card category-item' onClick={() => clickCategoryItem(category.name)}>
    <div className="icon-container">
      <img src={category.path ? `${utils.urls.cdnUrl}${category.path}` : `/images/icons/category-icon/${category.id}.png`}
        onError={(e) => { e.target.onerror = null; e.target.src = "/images/icons/category-icon/2.png" }} />
    </div>
    <span>{category.name}</span>
    <ArrowBackIosIcon style={{ color: '#1dc37e' }} />
  </Link>

export default ConsultCategoryItem
